import { literal, string, struct } from 'io-ts/lib/Decoder';

import { Opening } from '../frame/Opening';

/**
 * Sent when an opening is created and attached to a frame.
 * Server will recompute the frame geometry after creation.
 */
export const OpeningCreated = struct({
	type: literal('opening-created'),
	frameId: string,
	opening: Opening,
});
